// * import third party
import React from 'react';
import { EditIcon2, MoreIcon, TrashcanIcon } from '@assets/icons';
import { Box, Button, Text, Popover, PopoverTrigger, PopoverContent, PopoverBody, Flex } from '@chakra-ui/react';

// * import local
import { formatDate } from '@helpers/utils';
import { useConfirmModal } from '@store/useConfirmModal';
import { useApp } from '@pages/UploadMappingV2/context/AppContext';
import { ChevronDownIcon, ChevronRightIcon } from '@chakra-ui/icons';
import { useBundleStore } from '@pages/UploadMappingV2/hooks/state/useAddProductBundle';
import useMutateUploadMapping from '@pages/UploadMappingV2/hooks/mutate/useMutateUploadMapping';
import { ConfirmationState2 } from '@assets/images';

function ActionHead({ allValue }) {
    const { set } = useConfirmModal();
    const { setDirectEditBundle } = useBundleStore();
    const { deleteProductBundle } = useMutateUploadMapping();
    const { onOpenModalAddProductBundle } = useApp();

    const handleDelete = () => {
        set({
            isOpen: true,
            title: 'Hapus product?',
            desc: 'Data yang telah dituliskan akan hilang, perlu melakukan pengisian ulang untuk menambahkan atau menghubungkan produk.',
            btnLabelYes: 'Ya, Hapus',
            btnLabelNo: 'Kembali',
            ConfirmationStateImage: ConfirmationState2,
            onSubmit: () => deleteProductBundle.mutate(allValue.id),
        });
    };

    const handleEdit = () => {
        setDirectEditBundle(allValue);
        onOpenModalAddProductBundle();
    };

    return (
        <Popover placement="bottom-start">
            <PopoverTrigger>
                <Button variant={'unstyled'} justifySelf={'center'} px={0} minW={'10px'}>
                    <MoreIcon />
                </Button>
            </PopoverTrigger>
            <PopoverContent>
                <PopoverBody w={'full'} _hover={{ bg: 'sagitarius.100' }}>
                    <Button
                        variant={'unstyled'}
                        onClick={handleEdit}
                        color={'sagitarius.500'}
                        w={'full'}
                        justifyContent={'start'}
                    >
                        <EditIcon2 size={18} />
                        Edit
                    </Button>
                </PopoverBody>
                <PopoverBody _hover={{ bg: 'danger.100' }}>
                    <Button variant={'unstyled'} onClick={handleDelete} color={'danger.500'}>
                        <TrashcanIcon size={18} />
                        Delete
                    </Button>
                </PopoverBody>
            </PopoverContent>
        </Popover>
    );
}

export const tableHeadLists = [
    {
        key: 'name',
        title: 'Nama Bundle',
        width: '420px',
        isCanSort: true,
        tableDataList: ({ value, allValue }) => {
            const { expanded, toggleRow } = useApp();
            return (
                <Flex alignItems="center" gap={'8px'}>
                    <Button
                        variant="unstyled"
                        onClick={() => {
                            toggleRow(allValue.id);
                        }}
                    >
                        {expanded === allValue.id ? <ChevronDownIcon /> : <ChevronRightIcon />}
                    </Button>
                    <Text>{value}</Text>
                </Flex>
            );
        },
    },
    {
        key: 'code',
        title: 'Kode Produk di Toko',
        isCanSort: true,
        tableDataList: ({ value }) => {
            return (
                <Box>
                    <Text>{value}</Text>
                </Box>
            );
        },
    },
    {
        key: 'created_at',
        title: 'Date Created',
        isCanSort: true,
        tableDataList: ({ value }) => {
            return (
                <Box>
                    <Text>{formatDate(value, 'DD MMM YYYY, HH.mm')}</Text>
                </Box>
            );
        },
    },
    {
        key: 'action',
        title: 'Action',
        width: '100px',
        align: 'right',
        tableDataList: ({ allValue }) => {
            return <ActionHead allValue={allValue} />;
        },
    },
];
